export const tokens = {
    common: {
        total: '전체',
        choose_center: '센터 선택',
        fail: '실패',
        barcode_scan: '바코드스캔',
        accept: '확인',
        cancel: '취소',
        choose: '선택',
        shelf_over_limit: '유통기한 임박초과',
        damaged_goods: '상품 파손',
        defected_goods: '상품 불량',
        select_reason_for_return: '반품 사유 선택',
        please_enter_detailed_reason_for_return: '반품 사유를 상세히 입력해주세요',
        close: '닫기',
        complete: '완료',
        success: '성공',
        return_to_the_purchase: '매입처반품',
        reception_details: '접수 내역',
        list_of_recovery_codes: '회수 코드 목록',
        please_enter_the_product_name_or_barcode: '상품명, 인보이스 번호, 상품 바코드를 입력 해주세요',
        total_sum: '총',
        confirmation_of_arrival_processing: '입하처리 확인',
        add_item: '항목 추가',
        remove_item_: '항목 삭제',
        remove_item: '항목삭제',
        modify_entry_processing: '입하 처리 수정',
        complete_entry_processing: '입하 처리 완료',
        entry_processing: '입하 처리',
        order_form_temperature: '발주서 품온',
        center_selection_is_required: '센터 선택은 필수입니다',
        cannot_move_to_the_same_center: '같은 센터로 센터이동 할 수 없습니다',
        quantity_to_be_moved_must_be_entered: '이동 수량은 필수 입력해 주세요',
        please_enter_the_minimum_move_quantity_above: '최소 이동 수량은 이상으로 입력해 주세요',
        entered_movement_quantity_is_the_available_movement_quantity: '입력한 이동 수량이 이동가능수량',
        there_are_more: '보다 많습니다',
        move_center: '센터 이동',
        quantity_of_goods: '상품의 수량',
        count_move_center: '개를 센터이동 하겠습니까',
        please_enter_the_quantity_to_move: '이동하실 수량을 입력해 주세요',
        product_inquiry: '상품 조회',
        add_zone: '구역 추가',
        product_details: '상품 상세',
        movement_quantity_is_required: '이동수량은 필수 입력해 주세요',
        enter_the_minimum_movement_quantity_above: '최소 이동수량은 이상으로 입력해 주세요',
        would_you_count_move_center: '개를 이동 하겠습니까',
        select_return_type: '반품 유형 선택',
        select_return_type_is_required: '반품유형 선택은 필수입니다',
        please_enter_the_required_return_quantity: '반품수량은 필수 입력해 주세요',
        please_enter_the_minimum_return_quantity_above: '최소 반품수량은 이상으로 입력해 주세요',
        returned_quantity_entered_is_the_returnable_quatity: '입력한 반품수량이 반품가능수량',
        refund_reason_input_is_required: '반품사유 입력은 필수입니다',
        maximum_input: '최대 입력',
        entered_more_than_allowed: '보다 많이 입력했습니다',
        supplier_return: '매입처 반품',
        will_you_process_the_return_of_items: '개를 반품처리 하겠습니까',
        please_enter_the_quantity_to_return: '반품하실 수량을 입력해 주세요',
        please_enter_the_return_reason: '반품 사유를 입력해주세요',
        select_adjustment_type: '조정 유형 선택',
        selecting_adjustment_type_is_required: '조정 유형 선택은 필수입니다',
        please_enter_adjustment_quantity: '조정 수량은 필수 입력해 주세요',
        please_enter_minimum_adjustment_quantity_or_more: '최소 조정 수량은 이상으로 입력해 주세요',
        input_adjustment_quantity_is_adjustable_quantity: '입력한 조정 수량이 조정가능수량',
        inputting_expiration_date_is_required_when_adjusting_expiration_date: '유통기한 조정시 유통기한 입력은 필수입니다',
        goods: '상품',
        are_you_really_adjusting_the_expiration_date_for_this_reason: '사유로 유통기한을 조정 합니다 정말 조정 하시겠습니까',
        are_you_really_adjusting_the_stock_quantity_for_this_reason: '사유로 재고수량을 증감 합니다 정말 조정 하시겠습니까',
        are_you_really_adjusting_the_stock_quantity_down_for_this_reason: '사유로 재고수량을 차감 합니다 정말 조정 하시겠습니까',
        adjustment: '조정',
        please_enter_the_quantity_to_adjust: '조정할 수량을 입력해 주세요',
        interwarehouse_transfer: '창간 이동',
        row: '열',
        layer: '단',
        inventory_transfer_cancellation: '재고 이동취소',
        enter_location_code_or_scan_barcode: '로케이션 코드 입력 또는 바코드 스캔',
        inventory_movement_cancellation: '재고이동취소',
        replenishment_quantity_is_required: '보충수량은 필수 입니다',
        please_enter_the_quantity_to_replenish: '보충하실 수량을 입력해주세요',
        inventory_replenishment_scan: '재고보충 스캔',
        scan_departure_barcode: '출발지 바코드 스캔',
        please_scan_the_barcode: '바코드 스캔해 주시기 바랍니다',
        scan_arrival_barcode: '도착지 바코드 스캔',
        inventory_replenishment_has_been_processed: '재고 보충이 처리 되었습니다',
        scan_departure_location: '출발지 로케이션 스캔',
        scan_arrival_location: '도착지 로케이션 스캔',
        enter_investigation_quantity: '조사 수량 입력',
        please_enter_expiration_date_and_quantity: '유통기한과 수량을 입력해주세요',
        inventory_investigation_processing_completed: '재고 조사 처리가 완료 되었습니다',
        quantity: '수량',
        add: '추가',
        today: '오늘',
        initialize: '초기화',
        disposal_schedule_inquiry: '폐기예정 조회',
        enter_zone_name: '구역 이름 입력',
        select_zone: '구역 선택',
        common_password_is_required: '공통 비밀번호는 필수입니다',
        passwords_do_not_match: '비밀번호가 일치하지 않습니다',
        edit: '수정',
        additional_registration: '추가 등록',
        notification: '알림',
        zone: '구역',
        save: '저장',
        register: '등록',
        anpyeong: '안평',
        lee_hun_ju: '이헌주',
        local_line: '지선',
        search: '검색',
        please_enter_search_term: '검색어를 입력 하세요',
        no_records_found: '조회된 내역이 없습니다',
        customer_code: '매출처코드',
        contract_status: '계약상태',
        contract_date: '계약일',
        end_date: '종료일',
        customer_name: '매출처명',
        brand: '브랜드',
        designate: '지정',
        please_enter_id: '아이디를 입력하여 주십시오',
        please_enter_password: '패스워드를 입력하여 주십시오',
        please_enter_product_or_product_name: '상품 또는 상품명을 입력 해주세요',
        please_enter_product_info: '상품 ID 또는 상품명 또는 상품 바코드를 입력 해주세요',
        incoming_schedule_details: '입고 예정 상세',
        receive_modification: '입하 수정',
        incoming_schedule_list: '입고 예정 목록',
        stored_inventory: '보관재고',
        daily_inventory: '일재고',
        inventory_replenishment_details: '재고 보충 상세',
        inventory_replenishment_cancellation: '재고 보충 취소',
        replenishment_cancellation: '보충 취소',
        inventory_replenishment_list: '재고 보충 목록',
        inventory_audit: '재고조사',
        inventory_investigation: '재고 조사',
        in_progress: '진행중',
        no_inquiry_information_found: '조회 정보가 없습니다',
        item_count: '개',
        purpose: '용도',
        temperature: '온도',
        option: '옵션',
        individual_picking: '개별 피킹',
        please_scan_midmile_label_barcode: '간선 의 라벨 바코드를 스캔하세요',
        loading_inspection_completed: '상차검수완료',
        loading_inspection_pending: '상차검수대기',
        please_scan_product_label_barcode: '상품 라벨 바코드를 스캔해주세요',
        please_scan_total_picking_barcode: '토탈 피킹 바코드를 스캔해주세요',
        please_scan_individual_picking_barcode: '개별 피킹 바코드를 스캔해주세요',
        unable_to_connect_to_server_please_try_again_later: '서버와 연결할 수 없습니다 잠시 후 다시 시도해 주십시오',
        if_you_leave_the_page_your_work_will_not_be_saved: '페이지에서 나가면 작업 사항이 저장되지 않습니다',
        normal: '정상',
        date_3: '일자',
        hour: '시간',
        product_name: '상품명',
        product_barcode: '상품 바코드',
        product_temperature: '품온',
        purchase_name: '매입처명',
        total_plt_count: '총 PLT 수량',
        expiration_date: '유통기한',
        expiration_date_input: '유통기한 입력',
        order_unit_count: '발주 단위수량',
        actual_inbound_count: '실입고수량',
        accumulation_status: '적치 현황',
        order_unit: '주문 단위',
        complete_arrival_processing: '입하처리가 완료 되었습니다.',
        unit: '단위',
        departure: '출발',
        arrival: '도착',
        purchae_place: '매입처',
        label: '라벨',
        location_: '위치',
        last_modified_datetime: '최종변경일시',
        specification: '규격',
        sector: '섹터',
        no_loaded_items: '적재된 상품이 없습니다. 확인바랍니다.',
        not_placed: '미적치',
        actual_inventory: '실재고',
        scheduled_outbound: '출고예정',
        movable: '이동가능',
        storage_duration: '적치기간',
        day: '일',
        product: '상품',
        product_info: '상품 정보',
        remaining: '잔여',
        partial_cancellation: '부분취소',
        is_item: '상품입니다.',
        repack_and_rescan_item_qty: '상품 수량을 재포장 후 다시 스캔 해주세요.',
        order_canceled: '주문이 취소된',
        already_scanned: '이미 스캔 처리 된',
        is_logistics_code: '물류코드 입니다.',
        please_contact_center_admin: '센터관리자에게 문의해주세요.',
        unsent_logistics_code: '미출고 상태의 물류코드입니다.',
        logistics_number: '물류번호가',
        does_not_exist: '존재하지 않습니다.',
        pda_admin_password: 'PDA 관리자 비밀번호',
        no_items_to_transfer_to_center: '센터 이동할 상품 정보가 없습니다.',
        center_transfer_completed: '센터이동 처리가 완료 되었습니다.',
        network_error: '네트워크 에러',
        cannot_connect_server: '서버와 연결할 수 없습니다. 잠시 후 다시 시도해 주십시오.',
        lot_no: 'LOT',
        lot_no_input: 'LOT번호 입력',
        invoice_no: 'INVOICE NO',
        inbound_expected_significant: '입고예정서 특이사항',
        inbound_expected_goods_significant: '입고예정상품 특이사항',

    },
    inbound: {
        incoming_management: '입고 관리',
        midmile: '간선 입고',
        complete_: '입고 완료',
        complete: '입고완료',
        check_the_expected_receipt: '입고 예정서 조회',
        no_information_on_the_expected_receipt_inquiry: '입고예정서 조회 정보가 없습니다',
        greater_than_expected_quantity_received: '"입고예정 수량보다 실입고 수량이 많습니다\n' + '강제 입고처리를 진행해 주시기 바랍니다"',
        admission_processing: '입하처리',
        inbound_mi_processing: '미입고처리',
        inbound_mi_processing_confirm_text: '미입고 처리를 하시겠습니까?',
        inbound_mi_processing_success_text: '미입고 처리를 완료하였습니다.',
        inbound_stack: '입고 적치',
        incoming_confirmation: '입고 확인',
        midmile_incoming: '간선 입고',
        please_scan_midmile_incoming_label_barcode: '간선 입고 라벨 바코드를 스캔하세요',
        incoming_waiting: '입고대기',
        return_incoming: '회수 입고',
        please_scan_return_incoming_label_barcode: '회수 입고 라벨 바코드를 스캔해주세요',
        new_incoming: '신규 입고',
        date_time: '입고일시',
        less_then_expted_midlmile_plt_quantity: `입고 예정 PLT 수량보다 적습니다.\n간선 입고를 그대로 진행 하시겠습니까?`,
        complete_midlmile_inbound: '간선 입고 완료',
        processing_complete_midlmile_inbound: '간선 입고 완료 처리',
        inbound_center: '입고센터',
        receipt_plan_differs_from_info: '입고 예정서와 정보가 다릅니다.\n그래도 입하 처리를 진행하시겠습니까?',
        confirm_receipt_total_info: '총 {{total}}를 입하 처리 하시겠습니까?',
        no_receipt_data: '입하 자료가 없습니다.',
        receipt_processing_completed: '입고처리가 완료 되었습니다.',
        placement_qty: '적치 수량',
        view_expected_receipt: '입고 예정서 보기',
        total_expected_receipt_count: '총 {{total}} 개의 예정서',
        confirm_daily_stock_inbound_complete: '매입처의 일재고 상품을 입고 완료 처리 하시겠습니까?',
        completed_daily_stock_inbound: '[일재고]입고완료 처리 되었습니다.',
        not_a_returned_inbound_item_label_barcode: '회수 입고 상품 라벨 바코드가 아닙니다.',
        items_for_conversion_to_good_condition: '양품화 필요 목록',
        expected_stock_quantity: '입고예정수량',
        expected_lot_no: '입고예정LOT번호',
        lot_save_success_title: '상품 LOT 저장',
        lot_save_success_text: '상품 LOT 저장이 완료 되었습니다.',
        lot_save_title:'상품 LOT 저장',
        lot_save_text:'상품 LOT 및 유효기간을 저장하시겠습니까?',
    },
    outbound: {
        management: '출고 관리',
        midmile_outgoing: '간선 출고',
        outgoing_management: '출고 관리',
        outgoing_confirmation: '출고 확인',
        please_sacn_midmile_outbound_label_barcode: '간선 출고 파레트 라벨 바코드를 스캔해주세요.',
        midmile_outgoing_complete: '간선 출고 완료',
        midmile_outgoing_complete_processing: '간선 출고 완료 처리',
        less_then_expted_midlmile_plt_quantity: '출고 예정 PLT 수량보다 적습니다.\n간선 출고를 그대로 진행 하시겠습니까?',
        completed_midmile_outgoing: '간선 출고 및 착지센터에 입고가 완료 되었습니다.',
        departure_and_arrival: '출/도착지',
        outbounded_at: '출고일시',
    },
    inventory: {
        limit: '재고조사 제한',
        quality_improvement: '양품화',
        dispose: '폐기',
        scan_the_location_of_the_quality_product_stack: '양품화 적치 로케이션 스캔',
        scanning_the_staging_location: '적치 로케이션 스캔',
        location_barcode_error: '로케이션 바코드 오류',
        location_barcode_information_is_incorrect: '로케이션 바코드 정보가 올바르지 않습니다',
        check_location_temperature: '로케이션 온도 확인',
        is_not_the_location_of: '의 로케이션이 아닙니다',
        check_location_usage: '로케이션 용도 확인',
        please_process_product_stacking_at_the_picking_storage_location: '상품 적치는 피킹 보관 로케이션으로 처리해 주시기 바랍니다',
        please_scan_the_location_label_barcode: '로케이션 라벨 바코드를 스캔해주세요',
        stock_movement: '재고 이동',
        inventory_adjustment: '재고 조정',
        location_inquiry: '로케이션 조회',
        add_location: '로케이션 추가',
        enter_location_name: '로케이션 이름 입력',
        edit_location_information: '로케이션 정보 수정',
        location_management: '로케이션 관리',
        sector: '섹터',
        bay: '베이',
        rack_row_number: '랙 열번호',
        rack_layer_count: '랙 단수',
        location_purpose: '로케이션 용도',
        location_option: '로케이션 옵션',
        location_temperature: '로케이션 온도',
        edit_location: '로케이션 수정',
        register_location: '로케이션 등록',
        add_sector: '섹터 추가',
        enter_sector_name: '섹터 이름 입력',
        select_sector: '섹터 선택',
        slow_moving_inventory_location: '부진 재고 로케이션',
        scheduled_disposal_location: '폐기 예정 로케이션',
        unused_location: '미사용 로케이션',
        incoming_location: '입고 로케이션',
        picking_location: '피킹 로케이션',
        takeback_location: '회수 로케이션',
        return_location: '반품 로케이션',
        scheduled_disposal_product_location: '폐기 예정 상품 로케이션',
        receiving_zone_location: '입고존 로케이션',
        picking_zone_location: '피킹존 로케이션',
        takeback_zone_location: '회수존 로케이션',
        return_zone_location: '반품존 로케이션',
        inventory_inquiry: '재고 조회',
        location_scan: '로케이션 스캔',
        location_information_not_found: '로케이션 정보가 없습니다',
        please_scan_location_barcode: '로케이션 바코드를 스캔해주세요',
        location_detail_inquiry: '로케이션 상세조회',
        location_code: '로케이션 코드',
        location_alias: '로케이션 별칭',
        location_detail: '로케이션 상세',
        location_information_inquiry: '로케이션 정보 조회',
        inquiring_location_information: '로케이션 정보를 조회하는',
        enter_location_label_code_or_scan_barcode: '로케이션 라벨코드 입력 또는 바코드 스캔',
        zone_name: '구역명',
        sector_name: '섹터명',
        bay_name: '베이명',
        row_number: '열 번호',
        layer_count: '단 수',
        inventory_replenishment: '재고 보충',
        inventory_management: '재고관리',
        inventory_control: '재고 관리',
        not_exists_location_code: '없는 로케이션 코드입니다',
        location_address: '로케이션 주소',
        please_scan_moving_location_code_or_barcode: '이동할 로케이션 코드나 바코드 스캔 입력해 주세요.',
        same_location_departure_and_arrival: `로케이션 출발지와 도착지가 같습니다. 다시 확인해 주세요.`,
        same_center_location: '동일 센터 내 로케이션입니다. 다시 확인해 주세요.',
        complete_stock_movement: '재고 이동 처리가 완료 되었습니다.',
        are_you_cancel_stock_movement_request: '재고 이동 요청을 취소하시겠습니까?',
        canceled_stock_movement_request: '재고 이동 요청이 취소 되었습니다.',
        location_to_move: '이동할 로케이션',
        please_check_again: '이 맞는지 다시 한번 확인해 주세요.',
        not_exists_diposal_schedule_stock: '폐기예정 상품이 없습니다.',
        disposal_schedule: '폐기 예정',
        location: '로케이션',
        empty_inventory_supplement_list: '재고 보충 내역이 없습니다.',
        label_code: '라벨코드',
        placement_item_count: '적치상품갯수',
        placement_rate: '적치율',
        inventory_info: '재고 정보',
        no_registered_zone_sector_info: '등록된 구역/섹터 정보가 없습니다.',
        no_location_modification_history: '로케이션 수정내역이 없습니다.',
        select_location_area: '로케이션 구역(Area)을 선택해 주세요.',
        select_location_sector: '로케이션 섹터(Sector)를 선택해 주세요.',
        select_rack_column_number: '랙(Rack) 열 번호를 선택해 주세요.',
        select_location_bay: '로케이션 베이(Bay)를 선택해 주세요.',
        select_rack_tier: '랙(Rack) 단 수를 선택해 주세요.',
        select_location_purpose: '로케이션 용도를 선택해 주세요.',
        select_location_option: '로케이션 옵션을 선택해 주세요.',
        select_location_temperature: '로케이션 온도를 선택해 주세요.',
        confirm_location_modification: '로케이션 수정 하겠습니까?',
        location_modified: '로케이션 수정 되었습니다.',
        no_registered_zone_info: '등록된 구역 정보가 없습니다.',
        no_registered_sector_info: '등록된 섹터 정보가 없습니다.',
        location_label_code: '로케이션 라벨코드',
        zone_code: '구역 코드',
        sector_code: '섹터 코드',
        bay_code: '베이 코드',
        rack: '랙',
        rack_code: '랙 코드',
        enter_location_zone_name: '로케이션 구역 이름을 입력해 주세요.',
        confirm_location_zone_addition: '로케이션 구역추가 하겠습니까?',
        zone_added: '구역 추가 되었습니다.',
        location_area_must_be_assigned: '로케이션 구역(Area)이 지정되어야 합니다. 확인해 주세요.',
        enter_location_sector_name: '로케이션 섹터 이름을 입력해 주세요.',
        confirm_location_sector_addition: '로케이션 섹터추가 하겠습니까?',
        sector_added: '섹터 추가  되었습니다.',
        no_inventory_items_to_move: '재고 이동할 상품 정보가 없습니다.',
        move_qty: '이동 수량',
        enter_minimum_move_qty_of_1_or_more: '최소 이동수량은 1이상으로 입력해 주세요.',
        entered_move_qty_exceeds_movable_qty: '입력한 이동수량이 이동가능수량',
        enter_minimum_return_qty_of_1_or_more: '최소 반품수량은 1이상으로 입력해 주세요.',
        no_items_to_return: '반품할 상품 정보가 없습니다.',
        return_processed: '반품 처리가 완료 되었습니다.',
        return_qty: '반품 수량',
        return_reason: '반품 사유',
        confirm_adjustment: '정말 조정 하시겠습니까?',
        adjust_consumption_deadline_due_to_reason: '사유로 유통기한을 조정 합니다.',
        adjust_inventory_qty_due_to_reason: '사유로 재고수량을 증감 합니다.',
        decrease_inventory_qty_due_to_reason: '사유로 재고수량을 차감 합니다.',
        inventory_adjustment_processed: '재고조정 처리가 완료 되었습니다.',
        adjustment_type: '조정 유형',
        adjustment_qty: '조정 수량',
        enter_minimum_adjustment_qty_of_1_or_more: '최소 조정 수량은 1이상으로 입력해 주세요.',
        consumption_deadline_required_for_adjustment: '유통기한 조정시, 유통기한 입력은 필수입니다.',
        lot_no_required_for_adjustment: 'LOT번호 조정시, LOT번호 입력은 필수입니다.',
        no_items_to_adjust: '조정할 상품 정보가 없습니다.',
        location_registration_completed: '로케이션 등록이 완료 되었습니다.',
        confirm_additional_registration: '추가로 등록 하시겠습니까?',
        confirm_inventory_replenishment_cancellation: '재고 보충을 취소 하시겠습니까?',
        replenishment_cancellation_successful: '보충 취소에 성공 했습니다',
        location_info: '로케이션 정보',
        destination_location: '도착지 로케이션',
        origin_location: '출발지 로케이션',
        replenishment_qty: '보충수량',
        inventory_survey_progress: '재고조사 진행현황',
        inventory_survey_date: '재고조사일',
        existing_consumption_deadline: '기존 유통기한',
        survey_consumption_deadline: '조사 유통기한',
        existing_qty: '기존 수량',
        survey_qty: '조사 수량',
        changed_qty: '변경 수량',
        modify_selected_location_info: '선택한 로케이션 정보를 수정합니다.',
    },
    code: {
        brd_stl_stt_cd_ny: '미확정',
        brd_stl_stt_cd_cf: '확정',
        brd_stl_stt_cd_er: '정산에러',
        brd_stl_typ_cd_dist: '유통매출',
        brd_stl_typ_cd_logi: '물류매출',
        brd_stl_typ_cd_none: '정산없음',
        gd_typ_e: '전용',
        gd_typ_g: '범용',
        invn_typ_day: '일재고',
        invn_typ_direct: '직송',
        invn_typ_keep: '보관재고',
        gd_tmp_typ_c: '냉장',
        gd_tmp_typ_f: '냉동',
        gd_tmp_typ_r: '실온',
        orgn_typ_d: '국내산',
        orgn_typ_i: '수입산',
        orgn_typ_o: '기타',
        sls_stt_bfe: '종료임박',
        sls_stt_con: '계약중',
        sls_stt_end: '종료',
        sls_stt_stp: '이용정지',
        sls_rtt_asign: '배정',
        sls_rtt_unasign: '미배정',
        gd_use_typ_end: '종결',
        gd_use_typ_unuse: '미사용',
        gd_use_typ_use: '사용',
        nation_ae: '아랍에미리트', // united arab emirates
        nation_am: '미국', // USA
        nation_an: '아르헨티나', // Argentina
        nation_as: '오스트리아', // Austria
        nation_au: '호주', // オーストラリア
        nation_bg: '벨기에', // Belgium
        nation_br: '바레인', // Bahrain
        nation_bz: '브라질', // brazil
        nation_ca: '캐나다', // Canada
        nation_cb: '콜롬비아', // Colombia
        nation_ch: '칠레', // Chile
        nation_cn: '중국', // china
        nation_cr: '코스타리카', // Costa Rica
        nation_dm: '덴마크', // Denmark
        nation_dn: '도미니카', // dominica
        nation_eg: '이집트', // Egypt
        nation_etc: '외국산', // 外国産
        nation_fg: '피지', // Fiji
        nation_fl: '핀란드', // Finland
        nation_fr: '프랑스', // france
        nation_gm: '독일', // germany
        nation_gn: '기니', // Guinea
        nation_gr: '그리스', // Greece
        nation_hk: '홍콩', // Hong Kong
        nation_id: '인도', // India
        nation_idn: '인도네시아', // Indonesia
        nation_il: '아일랜드', // Ireland
        nation_ir: '이란', // Iran
        nation_is: '이스라엘', // Israel
        nation_it: '이탈리아', // Italy
        nation_jp: '일본', // japan
        nation_mc: '멕시코', // Mexico
        nation_mgc: '마다가스카르', // Madagascar
        nation_mn: '모나코', // monaco
        nation_mr: '모로코', // morocco
        nation_ms: '말레이시아', // malaysia
        nation_mt: '모리타니아', // mauritania
        nation_my: '미얀마', // Myanmar
        nation_nd: '네덜란드', // Netherlands
        nation_ng: '나이지리아', // Nigeria
        nation_nw: '노르웨이', // Norway
        nation_nz: '뉴질랜드', // New Zealand
        nation_pc: '파키스탄', // Pakistan
        nation_pf: '태평양', // Pacific
        nation_pfc: '태평양', //
        nation_pg: '파라과이', // Paraguay
        nation_pl: '폴란드', // Poland
        nation_pp: '필리핀', // Philippines
        nation_pr: '페루', // peru
        nation_pt: '포르투갈', // Portugal
        nation_rsa: '남아프리카공화국', // south africa
        nation_ru: '러시아', // russia
        nation_sb: '세르비아', // Serbia
        nation_sd: '사우디아라비아', // Saudi Arabia
        nation_sea: '원양', // 遠洋
        nation_sg: '세네갈', // Senegal
        nation_sgp: '싱가포르', // singapore
        nation_sl: '스리랑카', // sri lanka
        nation_sp: '스페인', // spain
        nation_ss: '스위스', // Swiss
        nation_sw: '스웨덴', // sweden
        nation_tk: '튀르키예', // Turkye
        nation_tl: '태국', // thailand
        nation_ts: '튀니지', // Tunisia
        nation_tw: '대만', // taiwan
        nation_ub: '우즈베키스탄', // Uzbekistan
        nation_uk: '영국', // England
        nation_vt: '베트남', // Vietnam
        brd_stat_ei: '종료임박',
        brd_stat_en: '종료',
        brd_stat_st: '정상',
        sls_ctt_postpay: '후불',
        sls_ctt_prepay: '선불',
        pc_grnt_typ_e: '종료',
        pc_grnt_typ_i: '종료임박',
        pc_grnt_typ_n: '정상',
        pc_grnt_typ_none: '상태없음',
        pr_stt_direct: '자체배송',
        pr_stt_ic: '입고완료',
        pr_stt_if: '입고확정',
        pr_stt_ik: '입고확인',
        pr_stt_iw: '입고대기',
        pr_stt_pr: '발주요청',
        pr_stt_px: '발주취소',
        rtrn_prog_ab: '폐기처리',
        rtrn_prog_rx: '반품취소',
        rtrn_prog_rr: '반품접수',
        rtrn_prog_rc: '반품요청(확정)',
        rtrn_typ_bd: '상품 불량',
        rtrn_typ_bk: '상품 파손',
        rtrn_typ_sp: '유통기한 경과',
        pc_stl_typ_cf: '확정완료',
        pc_stl_typ_ny: '미확정',
        bond_pay_stt_npaid: '미납',
        bond_pay_stt_paid: '상환',
        crdt_stt_cd_e: '종료',
        crdt_stt_cd_n: '정상',
        crdt_stt_cd_s: '정지',
        adj_price_category_bond_adj: '채권조정',
        adj_price_category_claim: '클레임',
        adj_price_category_coast: '비용청구',
        adj_price_category_etc: '기타',
        adj_price_category_purchase: '사입비',
        adj_price_category_quick: '퀵비',
        adj_price_category_quick_purchase: '퀵/사입',
        adj_price_category_sales_adj: '매출조정',
        sbjct_rspns_center_mng: '센터관리자',
        sbjct_rspns_consultant: '상담원',
        sbjct_rspns_dlvr_mng: '배송매니저',
        sbjct_rspns_inbound: '입고지센터',
        sbjct_rspns_logistics: '물류사',
        sbjct_rspns_outbound: '출차지센터',
        sbjct_rspns_pc_mng: '구매담당자',
        sbjct_rspns_purchase: '매입처',
        sbjct_rspns_sales: '발주처',
        sbjct_rspns_sales_mng: '영업담당자',
        sls_stl_typ_cf: '확정완료',
        sls_stl_typ_er: '정산에러',
        sls_stl_typ_ff: '강제확정',
        sls_stl_typ_ny: '미확정',
        po_inb_stt_fi: '강제입고',
        po_inb_stt_mi: '미입고',
        po_inb_stt_ni: '정상입고',
        po_inb_stt_pi: '부분입고',
        rqsts_bad_02: '상품불량',
        rqsts_bad_break: '상품불량 파손',
        rqsts_brk_crm_2: '파손',
        rqsts_chn_mind: '단순변심',
        rqsts_cop_crm_2: '전산문의',
        rqsts_cor_dlvr_02: '대응배송',
        rqsts_cre_crm_2: '결제문의',
        rqsts_dlvr_crm_2: '배송문의',
        rqsts_dmg_py_2: '재화파손',
        rqsts_doc_crm_2: '서류요청',
        rqsts_dor_lck_2: '출입문미시건',
        rqsts_err_code_02: '에러코드',
        rqsts_err_stack_02: '오적재',
        rqsts_error: '오배송',
        rqsts_etc: '기타',
        rqsts_etc_02: '기타문의',
        rqsts_expired: '유통기한',
        rqsts_miss: '미배송',
        rqsts_no_st_crm2: '미입고',
        rqsts_open_clo_2: '냉장고개폐',
        rqsts_ord_crm_02: '발주문의',
        rqsts_over_st_2: '과입고',
        rqsts_pro_crm_2: '제품문의',
        rqsts_sup_data_02: '증빙자료',
        rqsts_unrecover2: '미회수',
        rqsts_wrg_ord_2: '오발주',
        rqsts_wrg_sto_2: '오입고',
        tkbck_prog_tc: '회수완료',
        tkbck_prog_tg: '회수중',
        tkbck_prog_tx: '회수취소',
        tkbck_prcsn_done: '회수정상종료',
        tkbck_prcsn_fc: '완료',
        tkbck_prcsn_n: '미처리',
        tkbck_prcsn_pc: '부분완료',
        tkbck_prcsn_r: '대기중',
        tkbck_inb_ab: '폐기',
        tkbck_inb_gq: '양품화',
        tkbck_inb_qw: '양품대기',
        tkbck_inb_ret: '반품',
        tkbck_dlv_ab: '자체폐기',
        tkbck_dlv_c: '센터회수',
        mdlml_inb_stt_ic: '입고완료',
        mdlml_inb_stt_in_dlv: '배송중',
        mdlml_inb_stt_iw: '입고대기',
        mdlml_inb_stt_prtl_dlv: '부분배송',
        mdlml_inb_stt_xi: '미입고',
        ord_prog_dc: '배송완료',
        ord_prog_dd: '배송지연',
        ord_prog_dw: '배송중',
        ord_prog_oc: '주문확정',
        ord_prog_or: '주문접수',
        ord_prog_ox: '주문취소',
        ord_prog_pd: '부분배송',
        ord_cancel_ok: '정상',
        ord_cancel_ox: '전체취소',
        ord_cancel_pc: '부분취소',
        outb_stt_e: '미출',
        outb_stt_el: '미상차',
        outb_stt_k: '확인필요',
        outb_stt_n: '정상',
        outb_stt_pd: '부분배송',
        outb_stt_q: '선출고',
        outb_stt_ro: '재출고',
        outb_stt_x: '취소',
        outb_typ_emrg: '긴급출고',
        outb_typ_last: '지선',
        outb_typ_mid: '간선',
        issu_src_e: '미출',
        issu_src_el: '미상차',
        issu_src_k: '확인필요',
        issu_src_n: '정상',
        issu_src_pd: '부분배송',
        issu_src_q: '선출고',
        issu_src_ro: '재출고',
        issu_src_x: '취소',
        center_issu_e: '긴급출고',
        center_issu_o: '출고지시',
        center_issu_r: '요청취소',
        center_issu_ro: '재출고지시',
        center_issu_x: '주문취소',
        issu_prcsn_cr: '고객요청',
        issu_prcsn_dd: '배송지연',
        issu_prcsn_et: '기타',
        issu_prcsn_gb: '상품불량,파손',
        issu_prcsn_ie: '재고부족',
        invn_adjs_typ_ab: '폐기',
        invn_adjs_typ_defective: '불량',
        invn_adjs_typ_los: '손망실 처리',
        invn_adjs_typ_ml: '미상차',
        invn_adjs_typ_rcv: '손망실복구',
        invn_adjs_typ_shl: '유통기한 조정',
        invn_adjs_typ_lot: 'LOT번호 수정',
        invnsu_prog_c: '완료',
        invnsu_prog_f: '확정',
        invnsu_prog_w: '진행중',
        invn_prcsn_ab: '폐기',
        invn_prcsn_ci: '창간입고',
        invn_prcsn_co: '창간출고',
        invn_prcsn_defective: '불량',
        invn_prcsn_in: '입고',
        invn_prcsn_los: '손망실 처리',
        invn_prcsn_mov: '이동',
        invn_prcsn_out: '출고',
        invn_prcsn_rcv: '손망실복구',
        invn_prcsn_ret: '반품',
        invn_prcsn_shl: '유통기한 조정',
        invn_prcsn_tb: '회수',
        lct_typ_bd: '조정존',
        lct_typ_db: '분배존',
        lct_typ_et: '기타',
        lct_typ_in: '입고존',
        lct_typ_jb: '작업존',
        lct_typ_kp: '보관존',
        lct_typ_mv: '이동존',
        lct_typ_ot: '출고존',
        lct_typ_pk: '피킹존',
        lct_typ_rt: '반품존',
        lct_typ_tk: '회수존',
        tm_dlv_stat_dlv_cpl: '배송완료',
        tm_dlv_stat_in_dlv: '배송중',
        tm_dlv_stat_inb_wait: '입차대기중',
        tm_dlv_stat_load_inspc: '상차검수중',
        tm_dlv_stat_load_wait: '상차대기중',
        dlv_ml_last: '지선',
        dlv_ml_mid: '간선',
        tm_biz_type_prsnl: '개인',
        tm_biz_type_trnsp: '운수사',
        tm_cntr_stat_cntr_end: '계약종료',
        tm_cntr_stat_under_cntr: '계약중',
        stlprg_mnt_next_mth: '익월',
        stand_dt_1: '1',
        stand_dt_10: '10',
        stand_dt_15: '15',
        stand_dt_20: '20',
        stand_dt_25: '25',
        stand_dt_5: '5',
        stand_dt_last: '말일',
        cnsln_typ_cd_claim: '클레임',
        cnsln_typ_cd_common: '일반',
        cnsln_typ_cd_issue: '출고이슈',
        cnsln_typ_cd_msg: '문자발송',
        cnsln_typ_cd_recall: '반품/교환',
        cnsln_typ_cd_urgnt_dlvr: '긴급출고',
        crm_gnr_inq_break_crm_01: '파손',
        crm_gnr_inq_comp_crm_01: '전산문의',
        crm_gnr_inq_cr_dlvr_1: '대응배송',
        crm_gnr_inq_cred_crm_01: '결제문의',
        crm_gnr_inq_dlvr_crm_01: '배송문의',
        crm_gnr_inq_dlvr_rt: '배송 • 회수 문의',
        crm_gnr_inq_dmg_py_01: '재화파손',
        crm_gnr_inq_docu_crm_01: '서류요청',
        crm_gnr_inq_door_lo_1: '출입문미시건',
        crm_gnr_inq_er_code_1: '에러코드',
        crm_gnr_inq_err_st_1: '오적재',
        crm_gnr_inq_etc: '기타 문의',
        crm_gnr_inq_etc_01: '기타문의',
        crm_gnr_inq_goods_inq: '상품 문의',
        crm_gnr_inq_no_st_cr_1: '미입고',
        crm_gnr_inq_open_cl_1: '냉장고개폐',
        crm_gnr_inq_ord_crm_01: '발주문의',
        crm_gnr_inq_ord_stl: '주문 • 정산 문의',
        crm_gnr_inq_over_st_1: '과입고',
        crm_gnr_inq_prod_crm_01: '제품문의',
        crm_gnr_inq_sup_da_01: '증빙자료',
        crm_gnr_inq_sys: '시스템 문의',
        crm_gnr_inq_unrecover_01: '미회수',
        crm_gnr_inq_wng_or_1: '오발주',
        crm_gnr_inq_wng_st_1: '오입고',
        crm_dtl_ty_bad: '상품불량',
        crm_dtl_ty_bad_pack: '포장불량',
        crm_dtl_ty_break: '상품파손',
        crm_dtl_ty_break_crm: '파손',
        crm_dtl_ty_comp_crm: '전산문의',
        crm_dtl_ty_cor_dlvr: '대응배송',
        crm_dtl_ty_cred_crm: '결제문의',
        crm_dtl_ty_dlvr_crm: '배송문의',
        crm_dtl_ty_dly_dlvr: '지연배송',
        crm_dtl_ty_dmg_pry: '재화파손',
        crm_dtl_ty_docu_crm: '서류요청',
        crm_dtl_ty_door_lock: '출입문미시건',
        crm_dtl_ty_err_code: '에러코드',
        crm_dtl_ty_err_ln_bd: '여신・채권 오류',
        crm_dtl_ty_err_ord: '주문불가 오류',
        crm_dtl_ty_err_price: '정산금액 오류',
        crm_dtl_ty_err_recall: '오회수',
        crm_dtl_ty_err_stack: '오적재',
        crm_dtl_ty_etc: '기타',
        crm_dtl_ty_expired_dt: '유통기한',
        crm_dtl_ty_misdlvr: '오배송',
        crm_dtl_ty_no_st_cr: '미입고',
        crm_dtl_ty_open_close: '냉장고개폐',
        crm_dtl_ty_ord_crm: '발주문의',
        crm_dtl_ty_over_st: '과입고',
        crm_dtl_ty_prod_crm: '제품문의',
        crm_dtl_ty_sup_da: '증빙자료',
        crm_dtl_ty_undlvr: '미배송',
        crm_dtl_ty_unrecover: '미회수',
        crm_dtl_ty_wrg_ord: '오발주',
        crm_dtl_ty_wrg_st: '오입고',
        return_stt_cd_approve: '반품승인',
        return_stt_cd_receipt: '접수',
        return_stt_cd_reject: '반려',
        prcsn_stt_cd_done: '완료',
        prcsn_stt_cd_incomplete: '미완료',
        prcsn_stt_cd_rc: '요청취소',
        crm_process_type_e: '교환',
        crm_process_type_r: '반품',
        crm_type_basc_ask: '일반문의',
        crm_type_break_bad: '상품 파손 • 불량',
        crm_type_claim_ask: '클레임',
        crm_type_dlvr_rt: '배송 • 회수',
        crm_type_etc_ask: '기타',
        crm_type_ord_stl: '주문 • 정산',
        noti_state_noti: '공지중',
        noti_state_noti_end: '공지 종료',
        notice_ctg_brand_cal: '채권•정산',
        notice_ctg_etc: '기타',
        notice_ctg_goods: '상품',
        notice_ctg_ord_deli: '주문•배송',
        notice_ctg_system: '시스템',
        grnt_typ_cash: '현금',
        grnt_typ_credit: '신용',
        grnt_typ_pgrnt: '이행보증보험',
        tm_dlv_cpl_stat_dlv_cpl: '배송완료',
        tm_dlv_cpl_stat_in_dlv: '배송중',
        tm_dlv_cpl_stat_no_dlv: '미배송',
        tm_dlv_cpl_stat_prtl_dlv: '부분배송',
        bond_typ_cd_adj: '조정금',
        bond_typ_cd_en: '해지',
        bond_typ_cd_in: '입금',
        bond_typ_cd_mig: '매출이관',
        bond_typ_cd_out: '출금',
        bond_typ_cd_st: '생성',
        all: 'all',
        canceled: 'canceled',
        region: 'region',
        select_region: 'select_region',
        outbound_complete_processing: 'outbound_complete_processing',
        selected_orders_outbound_complete_processing: 'selected_orders_outbound_complete_processing',
        outbound_complete_processing_under_conditions: 'outbound_complete_processing_under_conditions',
        sales_partner: 'sales_partner',
        select_sales_partner: 'select_sales_partner',
        // select_area: '権域選択',
        outbound_complete_processing_according_to_selected_conditions: 'outbound_complete_processing_according_to_selected_conditions',
        completion: 'completion',
        parcel: '택배',
        truck: '트럭',
        ft20: '20FT',
        ft40: '40FT',
        invn_mv_typ_c: '창간이동',
        invn_mv_typ_m: '재고이동',
        invn_mv_prog_n: '미적치',
        invn_mv_prog_c: '완료',
        invn_my_prog_x: '취소',
        inb_prog_cd_ie: '입고예정',
        inb_prog_cd_iw: '입고대기',
        inb_prog_cd_uc: '입하완료',
        inb_prog_cd_mi: '미입고',
        inb_prog_cd_pi:  '부분입고',
        inb_prog_cd_ic: '입고완료',
    },
    error:{
        inbound_mi_error_title:'미입고 처리 오류',
        inbound_mi_error_text:'미입고 처리시 오류가 발생하였습니다.',
        inbound_lot_error_title:'상품 LOT 조회 오류',
        inbound_lot_error_text:'상품 LOT 조회 오류가 발생하였습니다.',
        inbound_lot_save_error_title:'상품 LOT 저장 오류',
        inbound_lot_save_error_text:'상품 LOT 오류가 발생하였습니다.',
    }
}
